import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enHome from './en/home.json';
import enErrors from './en/errors.json';
import esHome from './es/home.json';
import esErrors from './es/errors.json';

export const resources = {
  en: {
    home: enHome,
    errors: enErrors,
  },
  es: {
    home: esHome,
    errors: esErrors,
  },
} as const;

i18n.use(initReactI18next).init({
  lng: 'es',
  resources,
  ns: ['home'],
});
